import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as fragments from '../fragments'

const DOC = gql`
  ${fragments.spaceRecord.DOC}
  query SpaceRecords(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $filter: SpaceRecordsFilterInput
    $pagination: SpaceRecordsPaginationInput
    $sort: SpaceRecordsSortInput
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                spaceRecords(
                  filter: $filter
                  pagination: $pagination
                  sort: $sort
                ) {
                  ...FragmentSpaceRecord
                }
              }
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.SpaceRecordsQuery,
    ents.extra.space.Record[],
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'app',
        graphql.transformers.OUT.select(
          'scenario',
          graphql.transformers.OUT.select(
            'extra',
            graphql.transformers.OUT.select(
              'space',
              graphql.transformers.OUT.select(
                'spaceRecords',
                graphql.transformers.OUT.list(
                  fragments.spaceRecord.TRANSFORMER,
                  { onNullish: 'remove' },
                ),
              ),
            ),
          ),
        ),
      ),
    ),
  ),
  [],
)

export const executor = graphql.createExecutor<
  graphql.schema.SpaceRecordsQuery,
  ents.extra.space.Record[],
  graphql.schema.SpaceRecordsQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
